module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main"
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 7
    }
  }, [(!_vm.isBind) ? [_c('div', {
    staticClass: "section-card unbind-box"
  }, [_c('div', {
    staticClass: "content-center"
  }, [_c('i', {
    staticClass: "iconfont icon-exclamation-triangle"
  }), _vm._v(" "), _c('p', [_vm._v("您尚未绑定认证服务号，请先绑定!")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleBind
    }
  }, [_vm._v("去绑定")])], 1)])] : [_c('section', {
    staticClass: "section-card company"
  }, [(_vm.authorizerData) ? _c('img', {
    staticClass: "logo",
    attrs: {
      "src": _vm.authorizerData.head_img || 'https://fakeimg.pl/70x70/EFEFEF/CCC/?text=brand&font=lobster'
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.authorizerData.principal_name))]), _vm._v(" "), _c('div', {
    staticClass: "operate"
  }, [(_vm.isBind) ? _c('el-button', {
    attrs: {
      "type": "default",
      "size": "mini"
    },
    on: {
      "click": _vm.handleBind
    }
  }, [_vm._v("更新授权")]) : _c('el-button', {
    attrs: {
      "type": "default",
      "size": "mini"
    },
    on: {
      "click": _vm.handleBind
    }
  }, [_vm._v("去授权")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger",
      "size": "mini"
    },
    on: {
      "click": _vm.accountactivate
    }
  }, [_vm._v("账号续费")])], 1), _vm._v(" "), (_vm.activateInfo) ? _c('div', {
    staticClass: "validity-period"
  }, [_c('i', {
    staticClass: "iconfont icon-clock"
  }), _vm._v(_vm._s(_vm._f("datetime")(_vm.activateInfo.expired_at, 'yyyy-MM-dd hh:mm:ss')) + " 到期")]) : _vm._e()])]], 2), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 17
    }
  }, [_c('section', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.userloading),
      expression: "userloading"
    }],
    staticClass: "section-card realtime-statics"
  }, [_c('div', {
    staticClass: "section-card-header"
  }, [_c('div', {
    staticClass: "section-card-title"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t实时概况\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "header-small"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t更新时间：" + _vm._s(_vm._f("datetime")(Date.now() / 1000, 'yyyy-MM-dd hh:mm:ss')) + "\n\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('div', [_c('el-row', {
    staticClass: "analysis",
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "view-flex"
  }, [_c('div', {
    staticClass: "view-flex-item"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("实付金额(元)")]), _vm._v(" "), (_vm.staticsData) ? _c('div', {
    staticClass: "real-data"
  }, [_vm._v(_vm._s(_vm._f("keepTwoDecimalFull")(_vm.staticsData.today_data.real_payed_fee / 100)))]) : _vm._e(), _vm._v(" "), (_vm.staticsData) ? _c('div', {
    staticClass: "history-data"
  }, [_vm._v("昨日：" + _vm._s(_vm._f("keepTwoDecimalFull")(_vm.staticsData.yesterday_data.real_payed_fee / 100)))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "view-flex-item"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("支付订单数")]), _vm._v(" "), _c('div', {
    staticClass: "real-data"
  }, [_vm._v(_vm._s(_vm.staticsData && _vm.staticsData.today_data.real_payed_orders))]), _vm._v(" "), _c('div', {
    staticClass: "history-data"
  }, [_vm._v("昨日：" + _vm._s(_vm.staticsData && _vm.staticsData.yesterday_data.real_payed_orders))])])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "view-flex"
  }, [_c('div', {
    staticClass: "view-flex-item"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("实付会员数")]), _vm._v(" "), _c('div', {
    staticClass: "real-data"
  }, [_vm._v(_vm._s(_vm.staticsData && _vm.staticsData.today_data.real_payed_members))]), _vm._v(" "), _c('div', {
    staticClass: "history-data"
  }, [_vm._v("昨日：" + _vm._s(_vm.staticsData && _vm.staticsData.yesterday_data.real_payed_members))])]), _vm._v(" "), _c('div', {
    staticClass: "view-flex-item"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("客单价(元)")]), _vm._v(" "), (_vm.staticsData) ? _c('div', {
    staticClass: "real-data"
  }, [_vm._v(_vm._s(_vm._f("keepTwoDecimalFull")(_vm.staticsData.today_data.real_atv / 100)))]) : _vm._e(), _vm._v(" "), (_vm.staticsData) ? _c('div', {
    staticClass: "history-data"
  }, [_vm._v("昨日：" + _vm._s(_vm._f("keepTwoDecimalFull")(_vm.staticsData.yesterday_data.real_atv / 100)))]) : _vm._e()])])])], 1), _vm._v(" "), _c('el-row', {
    staticClass: "analysis",
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "view-flex"
  }, [_c('div', {
    staticClass: "view-flex-item"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("退款金额(元)")]), _vm._v(" "), (_vm.staticsData) ? _c('div', {
    staticClass: "real-data"
  }, [_vm._v(_vm._s(_vm._f("keepTwoDecimalFull")(_vm.staticsData.today_data.real_refunded_fee / 100)))]) : _vm._e(), _vm._v(" "), (_vm.staticsData) ? _c('div', {
    staticClass: "history-data"
  }, [_vm._v("昨日：" + _vm._s(_vm._f("keepTwoDecimalFull")(_vm.staticsData.yesterday_data.real_refunded_fee / 100)))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "view-flex-item"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("售后订单数")]), _vm._v(" "), _c('div', {
    staticClass: "real-data"
  }, [_vm._v(_vm._s(_vm.staticsData && _vm.staticsData.today_data.real_aftersale_count))]), _vm._v(" "), _c('div', {
    staticClass: "history-data"
  }, [_vm._v("昨日：" + _vm._s(_vm.staticsData && _vm.staticsData.yesterday_data.real_aftersale_count))])])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticClass: "view-flex"
  }, [_c('div', {
    staticClass: "view-flex-item"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("实新增储值金额(元)")]), _vm._v(" "), (_vm.staticsData) ? _c('div', {
    staticClass: "real-data"
  }, [_vm._v(_vm._s(_vm._f("keepTwoDecimalFull")(_vm.staticsData.today_data.real_deposit / 100)))]) : _vm._e(), _vm._v(" "), (_vm.staticsData) ? _c('div', {
    staticClass: "history-data"
  }, [_vm._v("昨日：" + _vm._s(_vm._f("keepTwoDecimalFull")(_vm.staticsData.yesterday_data.real_deposit / 100)))]) : _vm._e()])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticClass: "view-flex"
  }, [_c('div', {
    staticClass: "view-flex-item"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("当天实付金额(元)")]), _vm._v(" "), (_vm.staticsData) ? _c('div', {
    staticClass: "real-data"
  }, [_c('div', {
    staticClass: "real-data"
  }, [_c('span', [_vm._v(_vm._s(_vm._f("keepTwoDecimalFull")(_vm.staticsData.now_data.total_fee / 100)))])]), _vm._v(" "), _c('div', {
    staticClass: "label"
  }, [_vm._v("退款: "), _c('span', [_vm._v(_vm._s(_vm._f("keepTwoDecimalFull")(_vm.staticsData.now_data.refund_fee / 100)))])]), _vm._v(" "), _c('div', {
    staticClass: "label"
  }, [_vm._v("售后退款: "), _c('span', [_vm._v(_vm._s(_vm._f("keepTwoDecimalFull")(_vm.staticsData.now_data.aftersales_fee / 100)))])])]) : _vm._e()])])])], 1), _vm._v(" "), _c('el-row', {
    staticClass: "analysis",
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticClass: "view-flex"
  }, [_c('div', {
    staticClass: "view-flex-item"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("到家实付/(元)")]), _vm._v(" "), (_vm.staticsData) ? _c('div', {
    staticClass: "real-data"
  }, [_c('div', {
    staticClass: "real-data"
  }, [_c('span', [_vm._v(_vm._s(_vm._f("keepTwoDecimalFull")(_vm.staticsData.source_data.yaoking_amount_payed_count / 100)))])]), _vm._v(" "), _c('div', {
    staticClass: "label"
  }, [_vm._v("退款: "), _c('span', [_vm._v(_vm._s(_vm._f("keepTwoDecimalFull")(_vm.staticsData.source_data.yaoking_refunded_count / 100)))])]), _vm._v(" "), _c('div', {
    staticClass: "label"
  }, [_vm._v("售后退款: "), _c('span', [_vm._v(_vm._s(_vm._f("keepTwoDecimalFull")(_vm.staticsData.source_data.yaoking_aftersales_fee / 100)))])])]) : _vm._e()])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticClass: "view-flex"
  }, [_c('div', {
    staticClass: "view-flex-item"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("优选实付/(元)")]), _vm._v(" "), (_vm.staticsData) ? _c('div', {
    staticClass: "real-data"
  }, [_c('div', {
    staticClass: "real-data"
  }, [_c('span', [_vm._v(_vm._s(_vm._f("keepTwoDecimalFull")(_vm.staticsData.source_data.yx_amount_payed_count / 100)))])]), _vm._v(" "), _c('div', {
    staticClass: "label"
  }, [_vm._v("退款: "), _c('span', [_vm._v(_vm._s(_vm._f("keepTwoDecimalFull")(_vm.staticsData.source_data.yx_refunded_count / 100)))])]), _vm._v(" "), _c('div', {
    staticClass: "label"
  }, [_vm._v("售后退款: "), _c('span', [_vm._v(_vm._s(_vm._f("keepTwoDecimalFull")(_vm.staticsData.source_data.yx_aftersales_fee / 100)))])])]) : _vm._e()])])])], 1)], 1)])])], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('section', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.userloading),
      expression: "userloading"
    }],
    staticClass: "section-card"
  }, [_c('div', {
    staticClass: "section-card-header"
  }, [_c('div', {
    staticClass: "section-card-title"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t重要提醒\n\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('div', {
    staticClass: "notices"
  }, [_c('div', {
    staticClass: "notices-group"
  }, [_c('div', {
    staticClass: "subtitle"
  }, [_vm._v("订单相关")]), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "notice-item",
    attrs: {
      "span": 12
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/order/entitytrade/tradenormalorders?tab=notship"
    }
  }, [_vm._v("待发货订单：" + _vm._s(_vm.staticsData && _vm.staticsData.notice_data.wait_delivery_count))])], 1), _vm._v(" "), _c('el-col', {
    staticClass: "notice-item",
    attrs: {
      "span": 12
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.toLink('aftersaleslist')
      }
    }
  }, [_vm._v("待处理退款：" + _vm._s(_vm.staticsData && _vm.staticsData.notice_data.aftersales_count))])]), _vm._v(" "), _c('el-col', {
    staticClass: "notice-item",
    attrs: {
      "span": 12
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/order/Refunderrorlogs"
    }
  }, [_vm._v("退款失败待处理：" + _vm._s(_vm.staticsData && _vm.staticsData.notice_data.refund_errorlogs_count))])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "notices-group"
  }, [_c('div', {
    staticClass: "subtitle"
  }, [_vm._v("商品相关")]), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "notice-item",
    attrs: {
      "span": 12
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/entity/goods/goodsphysical"
    }
  }, [_vm._v("总商品：" + _vm._s(_vm.staticsData && _vm.staticsData.notice_data.all_goods_count))])], 1), _vm._v(" "), _c('el-col', {
    staticClass: "notice-item",
    attrs: {
      "span": 12
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/entity/goods/goodsphysical?approve_status=onsale"
    }
  }, [_vm._v("实时在线产品数量：" + _vm._s(_vm.staticsData && _vm.staticsData.notice_data.up_goods_count))])], 1), _vm._v(" "), _c('el-col', {
    staticClass: "notice-item",
    attrs: {
      "span": 12
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/entity/goods/goodsphysical?approve_status=instock"
    }
  }, [_vm._v("下架商品：" + _vm._s(_vm.staticsData && _vm.staticsData.notice_data.down_goods_count))])], 1), _vm._v(" "), _c('el-col', {
    staticClass: "notice-item",
    attrs: {
      "span": 12
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/entity/goods/goodsphysical?tab=second"
    }
  }, [_vm._v("库存预警商品：" + _vm._s(_vm.staticsData && _vm.staticsData.notice_data.warning_goods_count))])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "notices-group"
  }, [_c('div', {
    staticClass: "subtitle"
  }, [_vm._v("营销相关")]), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "notice-item",
    attrs: {
      "span": 12
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/marketing/marketingseckill?status=in_sale"
    }
  }, [_vm._v("进行中的秒杀：" + _vm._s(_vm.staticsData && _vm.staticsData.notice_data.started_seckill_count))])], 1), _vm._v(" "), _c('el-col', {
    staticClass: "notice-item",
    attrs: {
      "span": 12
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/marketing/groupsindex?activeName=third"
    }
  }, [_vm._v("进行中的拼团：" + _vm._s(_vm.staticsData && _vm.staticsData.notice_data.started_gtoups_count))])], 1)], 1)], 1)])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 14
    }
  }, [_c('section', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.userloading),
      expression: "userloading"
    }],
    staticClass: "section-card chart-statics"
  }, [_c('canvas', {
    attrs: {
      "id": "canvas",
      "height": "120"
    }
  })])])], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('section', {
    staticClass: "section-card"
  }, [_c('div', {
    staticClass: "section-card-header"
  }, [_c('div', {
    staticClass: "section-card-title"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t常用功能\n\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('div', {
    staticClass: "quick-link clearfix"
  }, _vm._l((_vm.links), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "link-item",
      on: {
        "click": function($event) {
          return _vm.toLink(item.link)
        }
      }
    }, [_c('i', {
      staticClass: "iconfont",
      class: 'icon-' + item.icon,
      style: ('background:' + item.color)
    }), _vm._v(_vm._s(item.text))])
  }), 0)])])], 1), _vm._v(" "), _c('section', {
    staticClass: "section-card"
  }, [_c('el-row', {
    attrs: {
      "span": 20
    }
  }, [_c('div', {
    staticClass: "section-card-header"
  }, [_c('div', {
    staticClass: "section-card-title"
  }, [_vm._v("\n            昨日销量排行\n          ")])]), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "stripe": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "label": "序号",
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "item_bn",
      "label": "商品货号",
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "item_name",
      "label": "商品名称",
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "price",
      "label": "单价/元",
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "sales_count",
      "label": "新增销量"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "fixed_amount_count",
      "label": "新增成交额(优惠前)/（元）"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "settle_amount_count",
      "label": "新增成交额(实付价)/（元）"
    }
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-ba901df2", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ba901df2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/base/index.vue
// module id = 2917
// module chunks = 0